import { jsx as _jsx } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */

/*
This component is used for legacy Sales or Service Starter users (before March 3, 2020).
They will be eligible to buy the newer Sales/Service Starter SKUs, but should see this button instead of the checkout button.
This button redirects them to a interstitial page that warns the user about "sidegrading" to the new SKU.
*/
import styled from 'styled-components';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { REQUEST_SKU } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import VersionNumbers from 'self-service-api/constants/VersionNumbers';
import { productForSkuIdSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { productVersionSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { validatedQueryParamTermForSkuSelector } from 'pricing-pages-ui/selectors/OfferSelectors';
import { Metrics } from 'pricing-pages-ui/utils/metrics';
const StyledButton = styled(UIButton).withConfig({
  displayName: "SalesServiceSidegradeRedirectButton__StyledButton",
  componentId: "sc-1o31tg0-0"
})(["width:100%;line-height:23px !important;"]);

const SalesServiceSidegradeRedirectButton = ({
  use,
  className,
  history,
  skuId,
  additionalUnitQuantity,
  upgradeData,
  productLine,
  queryParamTerm,
  trackingSource
}) => {
  const apiName = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }).apiName);
  const queryParamTermToUse = useSelector(state => {
    const {
      skuId: legacySkuId
    } = productVersionSelector(state, {
      apiName,
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      versionNumber: VersionNumbers[apiName].LEGACY
    });
    return validatedQueryParamTermForSkuSelector(state, {
      skuId: legacySkuId,
      queryParamTerm: queryParamTerm
    });
  });
  useEffect(() => {
    getUsageTracker().track('legacySidegradeConfirmationButton', {
      action: 'viewed',
      productName: apiName,
      trackingSource
    });
  }, []);

  const onClick = () => {
    getUsageTracker().track('legacySidegradeConfirmationButton', {
      action: 'clicked',
      productName: apiName,
      trackingSource
    });
    Metrics.counter('buy-now-clicked', {
      source: upgradeData && upgradeData.uniqueId || 'sales service sidegrade redirect button'
    }).increment();
    history.push('/legacy-starter-confirmation', {
      skuId,
      productLine,
      queryParamTerm: queryParamTermToUse,
      additionalUnitQuantity
    });
  };

  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_SKU,
    upgradeData: upgradeData,
    children: /*#__PURE__*/_jsx(StyledButton, {
      use: use,
      className: className,
      onClick: onClick,
      "data-selenium-id": `${apiName}-legacy-interstitial-redirect-button`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pricingCtas.buyNow"
      })
    })
  });
};

export default withRouter(SalesServiceSidegradeRedirectButton);